/*
Dentist Edit Profile Form Component
================================================================================
*/

/*
Imports
------------------------------------------------------------
*/
// libs
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {
  Field,
  reduxForm
} from 'redux-form';

// app
import Input from 'components/Input';
import LabeledInput from 'components/LabeledInput';
import InputGroup from 'components/InputGroup';
// images deletion actions

// local
import styles from '../styles.module.css';
import validator from '../validator';

/*
Field Validators
------------------------------------------------------------
*/

/*
Edit Profile Form
================================================================================
*/

@reduxForm({
  form: 'out-of-network-tab5',
  enableReinitialize:true,
  validate: validator,
})
@CSSModules(styles, { allowMultiple: true })
export default class Tab5 extends React.Component {

  constructor (props) {
    super(props);
    this.state={
      discount:props.initialValues.discount,
      writeOffOne: props.initialValues.writeOffOne,
      writeOffOneReimbursment: props.initialValues.ucrCost*((100-props.initialValues.writeOffOne)/100),
      writeOffTwo:props.initialValues.writeOffTwo,
      writeOffTwoReimbursment: props.initialValues.ucrCost*((100-props.initialValues.writeOffTwo)/100),
      writeOffThree:props.initialValues.writeOffThree,
      writeOffThreeReimbursment: props.initialValues.ucrCost*((100-props.initialValues.writeOffThree)/100),
      ucrCost:props.initialValues.ucrCost
    }
  }

  /*
  Actions
  ------------------------------------------------------------
  */



  getInput(props) {
    return new Input(props);
  }

  getLabeledInput(props) {
    return new LabeledInput(props);
  }


  getInputGroup(props) {
    return new InputGroup(props);
  }


  handleFormSubmit=(values)=>{
    this.props.changePercent2(values)
  }

  changeDiscount=(discount)=>{
    this.setState({discount:((discount==''||discount==null)?0:discount)})
  }

  onChangeWriteOff=(whichWriteOff,writeOffPercent)=>{
    if(whichWriteOff=='writeOffOne'){
      let writeOffOneReimbursment=this.props.initialValues.ucrCost*((100-writeOffPercent)/100)
      this.setState({...this.state,writeOffOneReimbursment:writeOffOneReimbursment,writeOffOne:writeOffPercent})
    }
    if(whichWriteOff=='writeOffTwo'){
      let writeOffTwoReimbursment=this.props.initialValues.ucrCost*((100-writeOffPercent)/100)
      this.setState({...this.state,writeOffTwoReimbursment:writeOffTwoReimbursment,writeOffTwo:writeOffPercent})
    }
    if(whichWriteOff=='writeOffThree'){
      let writeOffThreeReimbursment=this.props.initialValues.ucrCost*((100-writeOffPercent)/100)
      this.setState({...this.state,writeOffThreeReimbursment:writeOffThreeReimbursment,writeOffThree:writeOffPercent})
    }
  }


  /*
  Render
  ------------------------------------------------------------
  */

  render() {
    //if(this.state.ucrCost==null) this.props.change('discount',0)
    const flexcell = this.props.initialValues.memberCount!=null?"flex-cell6":"flex-cell5";

    console.log(this.props.initialValues)
    const {
        handleSubmit,
        submitting
      } = this.props;

      let full=this.props.initialValues.ucrCost*((100-this.state.discount)/100)
      let profit=full-this.props.initialValues.overheadCost;

    return (
      <form className="form-horizontal">
        <div className="container" styleName="tab5">
            <div styleName="introtext">
              <b>Boom.</b>
                  <h3>You only need to keep <span styleName="dhqblue">{parseInt(this.props.initialValues.memberCount*((this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost)/profit))}</span> of your {this.props.initialValues.memberCount} patients if you drop this carrier.</h3>
                  <p>(Or, put another way, you can afford to lose <span styleName="dhqblue">{(this.props.initialValues.memberCount) - parseInt(this.props.initialValues.memberCount*((this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost)/profit))}</span> patients.)</p>

                  <p>Better than you thought, right?</p>
            </div>

            <div styleName="final_container">

                <div styleName="flex-container header">
                    <div styleName={flexcell}><b>WRITE-OFF %</b></div>
                    <div styleName={flexcell}><b>PAID TO YOU</b></div>
                    <div styleName={flexcell}><b>COST</b></div>
                    <div styleName={flexcell}><b>PROFIT</b></div>
                    <div styleName={flexcell}><b>% NEEDED TO RETAIN</b></div>
                    {this.props.initialValues.memberCount!=null&&(<div styleName={flexcell}><b># PATIENTS</b></div>)}
                </div>
                {/* <div styleName="flex-container">
                    <div styleName={flexcell}>0 (full-fee)</div>
                    <div styleName={flexcell}>${parseFloat(full).toFixed(2)}</div>
                    <div styleName={flexcell}>${parseFloat(this.props.initialValues.overheadCost).toFixed(2)}</div>
                    <div styleName={flexcell}>${parseFloat(profit).toFixed(2)}</div>
                    <div styleName={flexcell}><span styleName="dhqblue">{this.state.writeOffOne==''?'-':(parseInt((this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost)/profit*100))}%</span></div>
                    {this.props.initialValues.memberCount!=null&&(<div styleName={flexcell}><span styleName="dhqblue">{parseInt(this.props.initialValues.memberCount*((this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost)/profit))}</span></div>)}
                </div> */}

                <div styleName="flex-container">
                    <div styleName={flexcell}>Full fee</div>
                    <div styleName={flexcell}>${parseFloat(full).toFixed(2)}</div>
                    <div styleName={flexcell}>${parseFloat(this.props.initialValues.overheadCost).toFixed(2)}</div>
                    <div styleName={flexcell}>${parseFloat(profit).toFixed(2)}</div>
                    <div styleName={flexcell}>-</div>
                    {this.props.initialValues.memberCount!=null&&(<div styleName={flexcell}>-</div>)}
                </div>

                <div styleName="flex-container">
                    <div styleName={flexcell}>
                      <Field
                    type="number"
                    name="writeOffOne"
                    component={this.getInputGroup}
                    onChange={(evt) => { this.onChangeWriteOff('writeOffOne',evt.target.value);}}
                    rightAddon="%"

                    />
                    </div>
                    <div styleName={flexcell}>{this.state.writeOffOne==''?'-':('$'+parseFloat(this.state.writeOffOneReimbursment).toFixed(2))}</div>
                    <div styleName={flexcell}>{this.state.writeOffOne==''?'-':('$'+parseFloat(this.props.initialValues.overheadCost).toFixed(2))}</div>
                    <div styleName={flexcell}>{this.state.writeOffOne==''?'-':('$'+parseFloat(this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost).toFixed(2))}</div>
                    <div styleName={flexcell}><span styleName="dhqblue">{this.state.writeOffOne==''?'-':(parseInt((this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost)/profit*100))}%</span></div>
                    {this.props.initialValues.memberCount!=null&&(<div styleName={flexcell}><span styleName="dhqblue">{parseInt(this.props.initialValues.memberCount*((this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost)/profit))}</span></div>)}
              </div>


                {/* <div styleName="flex-container">
                    <div styleName={flexcell}>
                      <Field type="number"
                    name="writeOffTwo"
                    component={this.getInputGroup}
                    onChange={(evt) => { this.onChangeWriteOff('writeOffTwo',evt.target.value);}}
                    rightAddon="%"

                    /></div>
                    <div styleName={flexcell}>{this.state.writeOffTwo==''?'-':('$'+parseFloat(this.state.writeOffTwoReimbursment).toFixed(2))}</div>
                    <div styleName={flexcell}>{this.state.writeOffTwo==''?'-':('$'+parseFloat(this.props.initialValues.overheadCost).toFixed(2))}</div>
                    <div styleName={flexcell}>{this.state.writeOffTwo==''?'-':('$'+parseFloat(this.state.writeOffTwoReimbursment-this.props.initialValues.overheadCost).toFixed(2))}</div>
                    <div styleName={flexcell}><span styleName="dhqblue">{this.state.writeOffTwo==''?'-':(parseInt((this.state.writeOffTwoReimbursment-this.props.initialValues.overheadCost)/profit*100))}%</span></div>
                    {this.props.initialValues.memberCount!=null&&(<div styleName={flexcell}><span styleName="dhqblue">{parseInt(this.props.initialValues.memberCount*((this.state.writeOffTwoReimbursment-this.props.initialValues.overheadCost)/profit))}</span></div>)}
                </div>
                <div styleName="flex-container">
                    <div styleName={flexcell}>
                      <Field type="number"
                    name="writeOffThree"
                    component={this.getInputGroup}
                    onChange={(evt) => { this.onChangeWriteOff('writeOffThree',evt.target.value);}}

                    rightAddon="%"
                    /></div>
                    <div styleName={flexcell}>{this.state.writeOffThree==''?'-':('$'+parseFloat(this.state.writeOffThreeReimbursment).toFixed(2))}</div>
                    <div styleName={flexcell}>{this.state.writeOffThree==''?'-':('$'+parseFloat(this.props.initialValues.overheadCost).toFixed(2))}</div>
                    <div styleName={flexcell}>{this.state.writeOffThree==''?'-':('$'+parseFloat(this.state.writeOffThreeReimbursment-this.props.initialValues.overheadCost).toFixed(2))}</div>
                    <div styleName={flexcell}><span styleName="dhqblue">{this.state.writeOffThree==''?'-':(parseInt((this.state.writeOffThreeReimbursment-this.props.initialValues.overheadCost)/profit*100))}%</span></div>
                    {this.props.initialValues.memberCount!=null&&(<div styleName={flexcell}><span styleName="dhqblue">{parseInt(this.props.initialValues.memberCount*((this.state.writeOffThreeReimbursment-this.props.initialValues.overheadCost)/profit))}</span></div>)}
                </div> */}
            </div>

            <div styleName="final_container_m">
              <div styleName="flex-container">
                  <div styleName="flex-cell-m"><b>WRITE-OFF</b></div>
                  <div styleName="flex-cell-m"><u><b>Full fee</b></u></div>
                  <div styleName="flex-cell-m"><u><b>{parseInt(this.state.writeOffOne)}%</b></u></div>
              </div>
              <div styleName="flex-container">
                  <div styleName="flex-cell-m"><b>PAID TO YOU</b></div>
                  <div styleName="flex-cell-m">${parseFloat(full).toFixed(2)}</div>
                  <div styleName="flex-cell-m">{this.state.writeOffOne==''?'-':('$'+parseFloat(this.state.writeOffOneReimbursment).toFixed(2))}</div>
              </div>
              <div styleName="flex-container">
                  <div styleName="flex-cell-m"><b>COST</b></div>
                  <div styleName="flex-cell-m">${parseFloat(this.props.initialValues.overheadCost).toFixed(2)}</div>
                  <div styleName="flex-cell-m">{this.state.writeOffOne==''?'-':('$'+parseFloat(this.props.initialValues.overheadCost).toFixed(2))}</div>
              </div>
              <div styleName="flex-container">
                  <div styleName="flex-cell-m"><b>PROFIT</b></div>
                  <div styleName="flex-cell-m">${parseFloat(profit).toFixed(2)}</div>
                  <div styleName="flex-cell-m">{this.state.writeOffOne==''?'-':('$'+parseFloat(this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost).toFixed(2))}</div>
              </div>
              <div styleName="flex-container">
                  <div styleName="flex-cell-m"><b>RETAIN %</b></div>
                  <div styleName="flex-cell-m">-</div>
                  <div styleName="flex-cell-m"><span styleName="dhqblue">{this.state.writeOffOne==''?'-':(parseInt((this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost)/profit*100))}%</span></div>
              </div>
              <div styleName="flex-container">
                  {this.props.initialValues.memberCount!=null&&(<div styleName="flex-cell-m"><b># PATIENTS</b></div>)}
                  {this.props.initialValues.memberCount!=null&&(<div styleName="flex-cell-m">-</div>)}
                  {this.props.initialValues.memberCount!=null&&(<div styleName="flex-cell-m"><span styleName="dhqblue">{parseInt(this.props.initialValues.memberCount*((this.state.writeOffOneReimbursment-this.props.initialValues.overheadCost)/profit))}</span></div>)}
              </div>
            </div>

            <div styleName="tryagain">
              <a onClick={this.props.restart}>Try again with another carrier &#8594;</a>
            </div>

            <div styleName="tab-notes">
                <p>If you’ve gotten this far, you’re at least curious about dropping a PPO.<br/>
                And the chart above shows you that the math could be in your favor.</p>
                <p>Still unsure? We’ve put together a comprehensive <b>Guide to Going Out Of Network</b> that will walk through the decision process, give you tips on how to tell your patients once you do decide, and show you how to keep those patients – and attract new ones – by utilizing the power of in-house membership plans.</p>
            </div>

            <div styleName="nextbutton">
                    <b>Download the Guide below.</b>
                </div>
            </div>

      </form>
    );
  }
}
